<template>
  <div>
    <AdminNavbar />
    <div v-if="!isReady">
      <div class="d-flex justify-content-center">
        <div class="col col-sm-8 col-md-6">
          <LoadingBar />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container mt-3">
        <CustomAlert
          v-if="0"
          title="Settings"
          type="warning"
          icon="bi-exclamation-circle"
        >
          <p class="mb-0">Under development.</p>
        </CustomAlert>

        <!-- Admin Settings Table -->
        <div class="card text-start shadow-sm">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="fs-4 mx-0 fw-bold">Manage {{ remappedName }}</div>
                <div class="fst-italic d-none">Edit your settings.</div>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <table class="table table-striped border mb-1">
              <thead>
                <tr>
                  <th class="ps-3">Key</th>
                  <th class="d-none">Type</th>
                  <th>Value</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="setting in settings" :key="setting.key">
                  <td class="ps-3 align-middle">{{ setting.key }}</td>
                  <td class="d-none align-middle">{{ setting.type }}</td>
                  <td class="align-middle">
                    <span v-if="setting.type === 'boolean'">
                      {{ setting.value ? "TRUE" : "FALSE" }}
                    </span>
                    <span v-else>{{ setting.value }}</span>
                  </td>
                  <td class="text-end align-middle">
                    <button
                      class="btn btn-warning btn-sm"
                      @click="openEditModal(setting)"
                    >
                      <i class="bi bi-pencil"></i
                      ><!-- Edit-->
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="editModalLabel"
      aria-hidden="true"
      ref="editModal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="editModalLabel">
              Edit {{ editableSetting ? editableSetting.key : "Setting" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="editableSetting">
              <CustomAlert title="">Edit the setting below.</CustomAlert>
              <p v-if="0"><strong>Key:</strong> {{ editableSetting.key }}</p>
              <p v-if="0">
                <strong>Type:</strong> {{ editableSetting.type || "string" }}
              </p>

              <div v-if="editableSetting.type === 'boolean'">
                <button
                  class="btn btn-secondary"
                  @click="editableSetting.value = !editableSetting.value"
                >
                  {{ editableSetting.value ? "TRUE" : "FALSE" }}
                </button>
              </div>

              <div v-else-if="editableSetting.type === 'date'">
                <input
                  type="date"
                  class="form-control"
                  v-model="editableSetting.value"
                />
              </div>

              <div v-else>
                <input
                  type="text"
                  class="form-control"
                  v-model="editableSetting.value"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-success" @click="saveSetting">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/admin/components/AdminNavbar";
import CustomAlert from "@/components/ui/CustomAlert";
import LoadingBar from "@/components/ui/LoadingBar";
import { Modal } from "bootstrap";
import { readSettings, updateSetting } from "@/apis/settings";
import { nameMapping } from "@/admin/index";
export default {
  name: "SettingsView",
  components: {
    AdminNavbar,
    CustomAlert,
    LoadingBar
  },
  computed: {
    remappedName() {
      let routeName = this.$route.name;
      return nameMapping[routeName] || routeName;
    }
  },
  data() {
    return {
      isReady: false,
      settings: [],
      editableSetting: null,
      modalInstance: null
    };
  },
  mounted() {
    if (this.$refs.editModal) {
      this.modalInstance = new Modal(this.$refs.editModal);
    }
  },
  methods: {
    openEditModal(setting) {
      if (!setting) {
        console.error("No setting provided to edit.");
        return;
      }

      this.editableSetting = {
        key: setting.key,
        type: setting.type || "string",
        value: setting.value
      };

      console.log("Opening modal for:", this.editableSetting);

      if (this.modalInstance) {
        this.modalInstance.show();
      } else {
        console.error("Modal instance not initialized.");
      }
    },

    saveSetting() {
      if (!this.editableSetting) {
        console.error("No setting to save.");
        return;
      }

      console.log("Saving setting:", this.editableSetting);

      updateSetting({
        key: this.editableSetting.key,
        value: this.editableSetting.value
      }).then(() => {
        const index = this.settings.findIndex(
          (s) => s.key === this.editableSetting.key
        );
        if (index !== -1) {
          this.settings[index].value = this.editableSetting.value;
        } else {
          console.warn(
            `Setting with key ${this.editableSetting.key} not found.`
          );
        }

        if (this.modalInstance) {
          this.modalInstance.hide();
        } else {
          console.error("Modal instance not initialized.");
        }
      });
    }
  },
  created() {
    readSettings().then((res) => {
      this.settings = res?.data?.message;
      this.isReady = true;
    });
  }
};
</script>
